import React from "react";

const Logo = ({ size = "md", className = "" }) => {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  };

  const textSizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
    xl: "text-4xl",
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Logo Icon - Use favicon */}
      <div className={`${sizeClasses[size]} flex items-center justify-center`}>
        <img
          src="/4.png"
          alt="HyperLogic"
          className={`${sizeClasses[size]} object-contain`}
        />
      </div>

      {/* Logo Text */}
      <span
        className={`${textSizes[size]} font-bold tracking-wide logo-text font-display`}
      >
        .AI
      </span>
    </div>
  );
};

export default Logo;
